import { template as template_35bbfcf3ca57470e96598f4ec1be9dc9 } from "@ember/template-compiler";
import type { TemplateOnlyComponent } from '@ember/component/template-only';
import { BaseDefinitionContainer, Active } from './base';
import { Clickable } from './clickable';
import type { BaseArgs, ActiveArgs } from './base';
import type { ClickableArgs } from './clickable';
interface FileArgs extends Omit<BaseArgs, 'title' | 'name' | 'isActive'>, ActiveArgs {
}
interface FileSignature {
    Element: HTMLElement;
    Args: FileArgs;
}
const FileDefinitionContainer: TemplateOnlyComponent<FileSignature> = template_35bbfcf3ca57470e96598f4ec1be9dc9(`
  <BaseDefinitionContainer
    @title='File'
    @name={{undefined}}
    @fileExtension={{@fileExtension}}
    @isActive={{true}}
    @fileURL={{@fileURL}}
    data-test-file-definition
  />
  <Active @actions={{@actions}} @infoText={{@infoText}} />
`, {
    eval () {
        return eval(arguments[0]);
    }
});
interface ModuleArgs extends BaseArgs, ActiveArgs {
}
interface ModSig {
    Element: HTMLElement;
    Args: ModuleArgs;
}
const ModuleDefinitionContainer: TemplateOnlyComponent<ModSig> = template_35bbfcf3ca57470e96598f4ec1be9dc9(`
  <BaseDefinitionContainer
    @title={{@title}}
    @name={{@name}}
    @fileExtension={{@fileExtension}}
    @isActive={{@isActive}}
    @fileURL={{@fileURL}}
    data-test-card-module-definition
  />
  {{#if @isActive}}
    <Active @actions={{@actions}} @infoText={{@infoText}} />
  {{/if}}
`, {
    eval () {
        return eval(arguments[0]);
    }
});
interface InstanceArgs extends Omit<BaseArgs, 'title' | 'isActive'>, ActiveArgs {
}
interface InstSig {
    Element: HTMLElement;
    Args: InstanceArgs;
}
const InstanceDefinitionContainer: TemplateOnlyComponent<InstSig> = template_35bbfcf3ca57470e96598f4ec1be9dc9(`
  <BaseDefinitionContainer
    @title='Card Instance'
    @fileExtension={{@fileExtension}}
    @name={{@name}}
    @isActive={{true}}
    @fileURL={{@fileURL}}
    data-test-card-instance-definition
  />
  <Active @actions={{@actions}} @infoText={{@infoText}} />
`, {
    eval () {
        return eval(arguments[0]);
    }
});
interface ClickableModuleArgs extends Omit<BaseArgs, 'infoText' | 'isActive'>, ClickableArgs {
}
interface ClickableModuleSignature {
    Element: HTMLElement;
    Args: ClickableModuleArgs;
}
const ClickableModuleDefinitionContainer: TemplateOnlyComponent<ClickableModuleSignature> = template_35bbfcf3ca57470e96598f4ec1be9dc9(`
    <Clickable
      @goToDefinition={{@goToDefinition}}
      @codeRef={{@codeRef}}
      @localName={{@localName}}
      data-test-clickable-definition-container
    >
      <BaseDefinitionContainer
        @title={{@title}}
        @name={{@name}}
        @fileExtension={{@fileExtension}}
        @isActive={{false}}
        @fileURL={{@fileURL}}
        data-test-card-module-definition
      />
    </Clickable>
  `, {
    eval () {
        return eval(arguments[0]);
    }
});
export { FileDefinitionContainer, ModuleDefinitionContainer, InstanceDefinitionContainer, ClickableModuleDefinitionContainer };
export { Divider } from './divider';
export { BaseContainer } from './base';
